import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { FUNNELS, track } from "@/lib/api";

const toneRing = {
  fear: "hover:border-red-500/60",
  trust: "hover:border-gold",
  strategy: "hover:border-emerald-500/60",
};

export default function FunnelLinks({ from = "" }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-testid="funnel-links">
      {FUNNELS.map((f) => (
        <Link
          key={f.slug}
          to={`/funnel/${f.slug}`}
          onClick={() => track("funnel_step", `${from}->${f.slug}`)}
          data-testid={`funnel-link-${f.slug}`}
          className={`group p-6 border border-white/10 bg-ink transition-colors ${toneRing[f.tone]}`}
        >
          <div className="flex items-start justify-between">
            <span className="font-mono2 text-gold text-xs uppercase tracking-widest">{f.kicker}</span>
            <ArrowUpRight className="w-5 h-5 text-white/40 group-hover:text-gold transition-colors" />
          </div>
          <div className="font-display text-2xl text-white mt-3 leading-tight">{f.title}</div>
          <div className="text-gold text-sm mt-3 font-medium">{f.cta} →</div>
        </Link>
      ))}
    </div>
  );
}
